<template >
    <div class="rotbox row" :style="{ width: totalHeight }">
      <div class="row-txt-l">{{$t('Webportal.Dashboard.Lambo.PridePerformanceKpi')}}</div>
      <div class="row-txt-m" :style="{ width: sectionHeight }">{{$t('Webportal.Section')}}</div>
      <div class="row-txt-r" :style="{ width: kpiHeight }">{{$t('Webportal.Kpi')}}</div>
    </div>
</template>

<script>
  export default {
    name: 'RotatedHeader',

    props: [ 'kpiHeight', 'sectionHeight', 'totalHeight' ]
  }
</script>

<style lang="scss" scoped>
  @import "@/../scss/lambo/variables.scss";

.rotbox  {
  margin:2px;
  position: relative;
  border: solid 1px $lambo-header-border;
  position: absolute;
  right: 100%;
  white-space: nowrap;
  font-weight: bold;
}
.rotbox::after {
  -webkit-transform: none;
  transform: none;
  margin: 0px;
}
.row {
  width: 480px;
  height: 30px;
  display: flex;
  align-items:flex-end;
  margin-right: unset;
  transform-origin: 100% 0%;
  transform:rotate(-90deg);
}
.row-txt-l {
  height: 100%;
  flex-grow:1;
  text-align: center;
  background-color: $lambo-header-color;
  border: solid 1px $lambo-header-border;
}
.row-txt-m{
  height: 100%;
  text-align: center;
  width: 99.5px;
  background-color: $lambo-header-color;
  border:solid 1px $lambo-header-border;
}
.row-txt-r {
  height: 100%;
  width: 41px;
  text-align: center;
  background-color: $lambo-header-color;
  border:solid 1px $lambo-header-border;
}
</style>
